import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Container, Table, Card, Row, Col, Badge } from "react-bootstrap";
import axios from "axios";
import '../../styles/OrderView.css'; 

const OrderView = () => {

  const { id } = useParams();
  const token = localStorage.getItem("admin_token");

  const [order, setOrder] = useState(null);
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    axios.get(`${API_BASE}/api/orders_a/${id}`,{headers})
      .then(res => setOrder(res.data))
      .catch(err => {
        console.error("Error fetching order", err);
        alert("Failed to load order details.");
      });
  }, [id]);

  const calculateTotal = () => {
    return order.items.reduce((sum, item) => sum + item.quantity * item.unit_price, 0).toFixed(2);
  };

  if (!order) return <p className="text-center mt-5">Loading order details...</p>;

  return (
    <Container className="mt-4">
      <h2 className="mb-4 text-primary">Order #{order.order_id}</h2>

      <Card className="mb-4 shadow-sm">
        <Card.Body>
          <Row className="mb-2">
            <Col><strong>Customer ID:</strong> {order.customer_id}</Col>
            <Col>
              <strong>Status:</strong>{" "}
              <Badge bg={order.order_status === "completed" ? "success" : "warning"}>
                {order.order_status}
              </Badge>
            </Col>
          </Row>
          <Row className="mb-2">
            <Col><strong>Order Date:</strong> {order.order_date}</Col>
            <Col><strong>Payment:</strong> {order.payment_status} ({order.payment_method})</Col>
          </Row>
          <Row className="mb-2">
            <Col><strong>Note:</strong> {order.customer_note || "N/A"}</Col>
            <Col><strong>Tracking Note:</strong> {order.tracking_note || "N/A"}</Col>
          </Row>
          <Row className="mb-2">
            <Col><strong>Delivered Date:</strong> {order.delivered_at || "N/A"}</Col>
          </Row>
        </Card.Body>
      </Card>

      <h5 className="mb-3">Bread Items</h5>

      <Table striped bordered hover responsive>
        <thead className="table-dark">
          <tr>
            <th>#</th>
            <th>Bread</th>
            <th>Size</th>
            <th>Quantity</th>
            <th>Unit Price</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          {order.items.map((item, i) => (
            <tr key={i}>
              <td>{i + 1}</td>
              <td>{item.bread_type}</td>
              <td>{item.size}"</td>
              <td>{item.quantity}</td>
              <td>${item.unit_price.toFixed(2)}</td>
              <td>${(item.unit_price * item.quantity).toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan="5" className="text-end"><strong>Grand Total</strong></td>
            <td><strong>${calculateTotal()}</strong></td>
          </tr>
        </tfoot>
      </Table>
    </Container>
  );
};

export default OrderView;
